import { render } from "./CardAdditionalGenerationCapacity.vue?vue&type=template&id=2a5b1122&scoped=true"
import script from "./CardAdditionalGenerationCapacity.vue?vue&type=script&lang=js"
export * from "./CardAdditionalGenerationCapacity.vue?vue&type=script&lang=js"

import "./CardAdditionalGenerationCapacity.vue?vue&type=style&index=0&id=2a5b1122&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a5b1122"]])

export default __exports__